
























































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import {
  agentsReports,
  AgentReportsBillParams,
  AgentReportsPaymentParams
} from "@/services/agent-reports";
import CField from "@/components/form/CField.vue";
import AgentBillFilter from "@/components/reports/AgentBillFilter.vue";
import AgentPaymentFilter from "@/components/reports/AgentPaymentFilter.vue";
import { Bill as IBill } from "@/api-v2/agent/models/bill";
import { Payment as IPayment } from "@/api-v2/agent/models/payment";
import AgentPaymentTable from "@/components/reports/AgentPaymentTable.vue";
import { uniqBy } from "lodash";
import AgentBillTable from "@/components/reports/AgentBillTable.vue";

@Component({
  components: {
    AgentBillTable,
    AgentPaymentTable,
    AgentPaymentFilter,
    AgentBillFilter,
    CField,
    CBlock,
    CPage
  }
})
export default class ReportList extends Vue {
  mode: "payments" | "bills" = "payments";
  bills: IBill[] = [];
  billsCount: number = 0;
  payments: IPayment[] = [];
  paymentsCount: number = 0;
  isLoading: boolean = false;

  async paymentApplyFilter(params?: AgentReportsPaymentParams) {
    this.payments = [];
    this.paymentsCount = 0;
    await this.getPayments(params);
  }

  async billApplyFilter(params?: AgentReportsBillParams) {
    this.bills = [];
    this.billsCount = 0;
    await this.getBills(params);
  }

  async getPayments(params?: AgentReportsPaymentParams) {
    try {
      this.isLoading = true;
      const { data } = await agentsReports.payments(params);
      this.payments = uniqBy([...this.payments, ...data.items], "id");
      this.paymentsCount = data.count;
    } catch (e) {
      throw new Error(e);
    } finally {
      this.isLoading = false;
    }
  }

  changeSortHandler(order: "ASC" | "DESC") {
    const params:
      | AgentReportsPaymentParams
      | AgentReportsBillParams = agentsReports.changeOrder(order);
    this.payments = [];
    this.paymentsCount = 0;
    this.getPayments(params as AgentReportsPaymentParams);
  }

  async getBills(params?: AgentReportsBillParams) {
    try {
      this.isLoading = true;
      const { data } = await agentsReports.bills(params);
      this.bills = uniqBy([...this.bills, ...data.items], "id");
      this.billsCount = data.count;
    } catch (e) {
      throw new Error(e);
    } finally {
      this.isLoading = false;
    }
  }

  changeDateAgentPaymentAt(value: {
    paymentId: string;
    agentPaymentAt?: Date;
  }) {
    const index = this.payments?.findIndex(el => el.id === value.paymentId);

    this.payments[index].agentPaymentAt = value.agentPaymentAt;
  }

  changeMode(mode: "bills" | "payments") {
    this.mode = mode;
    if (this.mode === "bills") this.getBills();
    if (this.mode === "payments") this.getPayments();
  }

  showMorePayments() {
    const params:
      | AgentReportsPaymentParams
      | AgentReportsBillParams = agentsReports.getParamsForShowMore();
    this.getPayments(params as AgentReportsPaymentParams);
  }

  showMoreBills() {
    const params:
      | AgentReportsPaymentParams
      | AgentReportsBillParams = agentsReports.getParamsForShowMore();
    this.getBills(params as AgentReportsBillParams);
  }

  async addAgentPaymentAt(value: { payments: IPayment[]; date: Date }) {
    value.date = value.date ?? new Date();

    try {
      this.isLoading = true;
      await agentsReports.editAgentPaymentAt(value.payments, value.date);
      this.$bvToast.toast(
        `${this.$t(this.$translate.ChangesHaveBeenSuccessfullySaved)}`,
        {
          variant: "success",
          title: `${this.$t(this.$translate.Successful)}`
        }
      );
      await this.paymentApplyFilter();
    } catch (e) {
      throw new Error(e);
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    if (this.mode === "bills") this.getBills();
    if (this.mode === "payments") this.getPayments();
  }
}
